<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
            <!-- <ion-button>
              <ion-icon slot="icon-only" name="menu"></ion-icon>
            </ion-button> -->
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="backIndex">Back to index</ion-button>
          <ion-button class="btn-back" @click="prev" v-if="index.prev"><span class="prev"></span></ion-button>
          <ion-button class="btn-back" @click="next" v-if="index.next"><span class="next"></span></ion-button>
          <ion-button class="btn-back" @click="backReport">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding ref="content">
      <ion-grid>
        <form @submit="save">
          <ion-row class="row-boxed mt-20">
            <ion-col size="12">
              <div class="title">Ref: {{index.ref}} - {{ index.title }}</div>
            </ion-col>
            <ion-col size="12" v-if="$store.state.user_role != 'client'">
              <div class="toolbar-add" @click="addItem">
                <img src="../assets/svg/icon-add-inverted.svg"> Add item
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="row-boxed mt-10" v-for="(iv, i) in index.value" :key="'val-'+i" :id="'val-'+i">
            <ion-col size="12">
              <div class="item-block">
                <div class="item-block-header">
                  <div class="first">ITEM</div>
                  <div class="second">ACCEPTED</div>
                  <div class="third">NOTES</div>
                </div>
                <div class="item-block-content" :class="iv.images.length > 0 ? 'item-block-content-img' : ''">
                  <div class="first">
                    <span>
                      <img @click="setIndexLightbox(i, 0)" :src="iv.images[0]" v-if="iv.images.length">
                      <CoolLightBox
                        v-if="iv.images.length"
                        :items="iv.images" 
                        :index="indexLightbox[i]"
                        @close="setIndexLightbox(i, null)">
                      </CoolLightBox>

                      {{ iv.name }}
                    </span>
                  </div>
                  <div class="light-wrapper second">
                    <div class="light" :class="iv.accepted == '3' ? 'green' : 'dark'"></div>
                    <div class="light" :class="iv.accepted == '2' ? 'yellow' : 'dark'"></div>
                    <div class="light" :class="iv.accepted == '1' ? 'red' : 'dark'"></div>
                  </div>
                  <div class="third">
                    <span v-if="iv.notes.length">{{ iv.notes[iv.notes.length-1].desc }}</span>
                  </div>
                </div>
                <div class="item-block-btns">
                  <ion-button v-if="$store.state.user_role != 'client'" type="button" @click="() => deleteIndex(i)">Delete</ion-button>
                  <ion-button v-if="$store.state.user_role != 'client'" type="button" color="dark" @click="() => editIndex(i)">Edit</ion-button>
                  <ion-button v-if="$store.state.user_role == 'client'" type="button" color="dark" @click="() => editIndex(i)">Details</ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row class="row-boxed" v-if="$store.state.user_role != 'client'">
            <ion-col size="12" class="text-right">
              <ion-button type="submit">SAVE</ion-button>
            </ion-col>
          </ion-row>
          <!-- Permette l'invio del form con tasto enter -->
          <input type="submit" class="hidden">
        </form>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
import Vue from "vue"
export default {
  name: "CompileIndexIndex",
  data: function() {
    return {
      index: { value: [] },
      loader: true,
      indexLightbox: [],
    }
  },
  methods: {
    setIndexLightbox: function(index, value){
      Vue.set(this.indexLightbox, index, value)
    },
    prev: async function() {
      await this.save(null)
      this.$router.push({name: 'compile-' + (this.index.prev.type == 'tt' ? 'text' : 'index'), params: { id: this.index.prev.id } });
      this.getIndex()
    },
    next: async function() {
      await this.save(null)
      this.$router.push({name: 'compile-' + (this.index.next.type == 'tt' ? 'text' : 'index'), params: { id: this.index.next.id } });
      this.getIndex()
    },
    backReport: async function() {
      await this.save(null)
      if(this.index.yacht_id) {
        this.$router.push('/report/'+this.index.yacht_id);
      } else {
        this.$router.back();
      }
    },
    backIndex: async function(){
      await this.save(null)
      this.$router.push('/report/details/'+this.index.report_id);
    },
    editIndex: async function(index) {
      this.save(false, () => this.$router.push({name: 'compile-index-item', params: { id: this.index.id, index: index } }) )
    },
    deleteIndex: function(index){
      return this.$ionic.alertController
      .create({
        header: 'Delete item',
        message: 'Are you sure to delete this item?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel'
          },
          {
            text: 'Confirm',
            handler: () => {
              this.index.value.splice(index, 1);
            },
          },
        ],
      })
      .then(a => a.present())
    },
    addItem: function() {
      let obj = {
        name: '',
        accepted: '',
        notes: [],
        images: [],
      }
      this.index.value.push(obj)
    },
    save: async function(ev, callback) {
      if (ev) {
        ev.preventDefault();
      }
      this.loader = true
      await axios.post(this.apiUrl + '/api/v1/save-index', { api_token: this.$store.state.api_token, index: this.index })
      .then(async () => {
        if (callback) {
          callback()
        } else {
          const toast = await this.$ionic.toastController.create({
            message: 'Index saved succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
          this.loader = false;
        }
      }).catch(async () => {
        this.loader = false
        const toast = await this.$ionic.toastController.create({
          message: 'Generic error. Try to save again.',
          color: 'danger',
          position: 'bottom',
          duration: 2000
        })
        await toast.present();
      })
    },
    getIndex: function(){
      axios.post(this.apiUrl + '/api/v1/get-index', { api_token: this.$store.state.api_token, id: this.$route.params.id })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.index = res.data
          this.index.value = this.index.value ? this.index.value : []
          let a = 0
          while (a < this.index.value.length) {
            this.setIndexLightbox(a, null)
            a++
          }
        }
        this.loader = false;

        if(this.$route.params.scroll) {
          setTimeout(() => {
            let toolbar = document.querySelector('ion-toolbar');
            let elem = document.getElementById('val-' + this.$route.params.scroll);
            let scroll = elem.offsetTop - toolbar.offsetHeight
            this.$refs['content'].scrollToPoint(0, scroll);
          }, 100);
        }
      }).catch(async () => {
        this.loader = false
        const toast = await this.$ionic.toastController.create({
          message: 'Generic error. We\'re trying to reload the page.',
          color: 'danger',
          position: 'bottom',
          duration: 3000
        })
        await toast.present();

        setTimeout(() => {
          window.location.reload()
        }, 3000)
      })
    }
  },
  mounted: function() {
    this.getIndex()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item-block-content-img {
  padding-left: 80px;
  min-height: 130px;
  position: relative;
}
.item-block-content-img img {
  position: absolute;
  left: 15px;
  top: 15px;
  width: 70px;
  height: auto;
}
</style>